module.exports = __webpack_public_path__ + "img/fob_03.31c3db78.png";